export const FEATURE_NAME = '@zerops/zerops/feature/service-ui-overlay';
